import { session, socket } from 'lib_ui-services';

// Allow mocking of dependencies for testing purposes, but use the real implementations in production.
const _private = {
    socket,
    session
};
export default {
    verb: 'doingRemove',
    namespace: 'security',
    relation: 'profile',
    description: 'Log out the current user',
    priority: 10,
    logic,
    _private
};

async function logic() {
    _private.socket.disconnect();
    await _private.session.logout();
}
